import UserService from './user_service';
import EventBus from './event_bus';
import axios from 'axios';

export default {
  install: function(Vue, parameters) {
    Vue.prototype.$bus = EventBus;
    Vue.prototype.$auth = UserService;
    Vue.prototype.$http = axios;
  }
};



// WEBPACK FOOTER //
// ./src/auth/auth.js